// extracted by mini-css-extract-plugin
module.exports = {"mobileNav":"MobileMenu_mobileNav__mTDnq","list":"MobileMenu_list__1Eg6u","item":"MobileMenu_item__1E6rQ"};